module.exports = __webpack_public_path__ + "img/item.d206e611.png";